import React from 'react'

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import { bool } from 'prop-types'

import Conversation from './Conversation/Conversation'
import Conversations from './Conversations/Conversations'

class Inbox extends React.Component {
  componentDidMount() {
    const staticPlaceholder = document.getElementsByClassName(
      'js-conversations-static'
    )[0]

    if (staticPlaceholder && staticPlaceholder.parentNode) {
      staticPlaceholder.parentNode.removeChild(staticPlaceholder)
    }
  }

  render() {
    const { newRoyaltyUi } = this.props
    return (
      <Router>
        <div>
          <Routes>
            <Route
              path="/profile/inbox"
              element={<Conversations newRoyaltyUi={newRoyaltyUi} />}
            />
            <Route
              path="/profile/inbox/conversations/:id"
              element={<Conversation newRoyaltyUi={newRoyaltyUi} />}
            />
          </Routes>
        </div>
      </Router>
    )
  }
}

Inbox.propTypes = {
  newRoyaltyUi: bool,
}

Inbox.defaultProps = {
  newRoyaltyUi: false,
}

export default Inbox
